import { API } from 'api';
import { MapPlacesAPIData } from './usePlaces.types';

export const MAP_PLACES_VERSION = 1;

export const MAP_PLACES_QUERY_KEY = ['mapPlaces'];

export const fetchMapPlaces = async (): Promise<MapPlacesAPIData | null> => {
  const response = await API.get('users/places/');
  const data = response.data?.data as MapPlacesAPIData;
  if (!data || data.version > MAP_PLACES_VERSION) {
    return null;
  }
  return data;
};

export const updateMapPlaces = async (
  update: MapPlacesAPIData,
): Promise<void> => {
  await API.put('users/places/', update);
};
